export const FIXED_SETTLEMENT_CURRENCIES = ['AUD', 'NZD'];

export const FIXED_SETTLEMENT_EXCHANGE_RATE_CURRENCIES = ['AUD', 'USD', 'NZD'];
